import React from 'react';

import { UIDomainEnums } from '../../../UILibrary';
import { ITextField } from '../../../UILibrary/domain/interfaces';
import { HTMLFormElementsFactory } from '../../../UILibrary/infrastructure/factories/HTMLFormElements.factory';
import { HTMLFormProperty } from '../../domain/abstract/HTMLFormProperty';
import {
  IFormClient,
  TInputFieldFormPropertyConstructor,
} from '../../domain/interface';

export class InputFieldFormProperty extends HTMLFormProperty {
  public readonly isEditable: boolean;
  public readonly isLoading: boolean;
  public readonly isDisplayable: boolean;
  public readonly initialValue: string;
  public readonly helperText: string | undefined;
  public readonly label: string | undefined;
  public readonly name: string | undefined;
  public readonly inputType = UIDomainEnums.HTMLFormTypeEnum.INPUT_FIELD;

  constructor(
    private readonly payload: TInputFieldFormPropertyConstructor,
    private readonly additionalTextInputFieldProps?: Partial<ITextField>,
  ) {
    super();
    Object.assign(this, payload);
  }

  public readonly renderFormTypeComponent: React.FC<{
    propertyName: string;
    formClient: IFormClient;
    isLoading?: boolean;
  }> = ({ propertyName, formClient, isLoading }) => {
    return (
      <HTMLFormElementsFactory.composeTextInputField
        {...this.additionalTextInputFieldProps}
        data-testid={propertyName}
        aria-labelledby={propertyName}
        name={propertyName}
        id={propertyName}
        isDisabled={!this.isEditable || isLoading}
        isReadOnly={!this.isEditable}
        value={formClient.values[propertyName]}
        onChange={(onChangeValue) => {
          formClient.setFieldValue(propertyName, onChangeValue);
          formClient.touched[propertyName] = true;
        }}
        helperText={
          formClient.touched[propertyName] && formClient.errors[propertyName]
        }
        validationState={this.setValidationStateProp(propertyName, formClient)}
      />
    );
  };

  public static readonly create = (
    inputFieldConfig?: {
      helperText?: string;
      label?: string;
    },
    formPropertyConfig?: Partial<TInputFieldFormPropertyConstructor>,
  ): HTMLFormProperty => {
    const { isEditable, isDisplayable, initialValue } =
      HTMLFormProperty.configureHTMLFormProperty(formPropertyConfig);

    return new InputFieldFormProperty({
      ...inputFieldConfig,
      isEditable,
      isDisplayable,
      initialValue,
    });
  };
}
